<script>

    import { toast } from 'bulma-toast'
    import { createEventDispatcher } from 'svelte'
    import { userStore } from '../stores'

    import QuotationsService from '../$services/quotations.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import Spinner from '../$components/spinner.svelte'
    import Message from '../$components/message.svelte'
    import Button from '../$components/button.svelte'

    const dispatch = createEventDispatcher()

    export let order = null
    export let quotation = null
    export let pickup = null
    export let delivery = null
    export let ipackage = null
    export let localServices

    let quotations = []
    let loading = true

    getQuotations()

    async function getQuotations() {

        const data = {
            pickup,
            delivery,
            package: ipackage,
            localServices
        }

        loading = true
        const resp = await QuotationsService.getQuotations(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        quotations = resp.data
    }

    function onSelected(item) {
        quotation = item
        dispatch('selected', item)
    }

</script>

<style>

    @media screen and (max-width: 500px) {
        .brand {
            display: none;
        }
    }
</style>

<Spinner {loading} />
<Message show={!loading && !quotations.length} message="Sin cobertura" />

{#if !loading && quotations.length}
    <div class="columns">
        <div class="column">
            <div class="columns">
                <div class="column">
                    <div class="title">Origen</div>
                    <div class="subtitle">{pickup.zipcode} {pickup.city || ''}</div>
                </div>
                <div class="column">
                    <div class="title">Destino</div>
                    <div class="subtitle">{delivery.zipcode} {delivery.city || ''}</div>
                </div>
                <div class="column">
                    <div class="title">Paquete</div>
                    <div class="subtitle">{ ipackage.width }cm x { ipackage.height }cm x { ipackage.length}cm | { ipackage.weight }Kg</div>
                </div>
            </div>
            {#if order && order.service}
                <div class="columns">
                    <div class="column">
                        <div class="notification items-center">
                            {#if order.service.code}
                                <div class="space-left">{ order.service.code }</div>
                            {/if}
                            {#if order.service.price}
                                <div class="space-left">${ order.service.price }</div>
                            {/if}
                        </div>
                    </div>
                </div>
            {/if}
            <hr>
            <div class="table-container">
                <table class="table is-fullwidth">
                    <tbody>
                        {#each quotations as quotation}
                            <tr>
                                <td class="brand">
                                    {#if ['TIL', 'Estafeta', 'Estafeta+', '99Minutos', 'FedEx', 'FedEx+', 'DHL', 'Paquetexpress', 'Paquetexpress+', 'EstafetaLTL', 'BigSmart', 'Genka'].includes(quotation.provider)}
                                        <img src="/images/{ quotation.provider }.svg" alt="{ quotation.provider }" style="max-width: 200px;">
                                    {:else}
                                        <img src="/images/{ quotation.provider }.png" alt="{ quotation.provider }" style="max-width: 200px;">
                                    {/if}
                                </td>
                                <td>
                                    <div class="title">{ quotation.provider }</div>
                                    <div class="subtitle">{ quotation.service }</div>
                                    <div class="tags">
                                        {#if quotation.insurancePrice && !$userStore.hidePrices}
                                            <span class="tag is-danger">Precio ${quotation.shipmentPrice} + Seguro ${quotation.insurancePrice}</span>
                                        {/if}
                                        {#if !quotation.isDeliveryHome}
                                            <span class="tag is-danger">Sin entrega a domicilio</span>
                                        {/if}
                                        {#if quotation.isCoverageCost}
                                            <span class="tag is-danger">Zona extendida</span>
                                        {/if}
                                        {#if quotation.paymentType === 'prepaid'}
                                            <span class="tag is-primary">Guía prepago { quotation.prepaidShipments }/{ quotation.prepaidShipmentsTotal }</span>
                                        {/if}
                                        {#if quotation.information}
                                            <span class="tag">{ quotation.information }</span>
                                        {/if}
                                    </div>
                                </td>
                                <td>
                                    {#if !$userStore.hidePrices}
                                        <div class="title">{ NumeralMethods.cash(quotation.finalPrice) }</div>
                                    {/if}
                                    <div class="subtitle">{ quotation.days } Dias</div>
                                    <Button on:click={() => onSelected(quotation)} icon="arrow-alt-circle-right" text="Continuar" color="primary" />
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
{/if}